export function hasSmartAccount(activeWallet) {
    const config = activeWallet?.getConfig();
    return (!!activeWallet &&
        (activeWallet.id === "smart" ||
            (activeWallet.id === "inApp" && !!config && "smartAccount" in config)));
}
//# sourceMappingURL=isSmartWallet.js.map